import { Spinner, Container } from "react-bootstrap";

const Loading = () => {
  return (
    <Container className="d-flex flex-column justify-content-center align-items-center vh-100">
      <Spinner
        animation="border"
        variant="primary"
        role="status"
        className="mb-3"
      />
      <h4 className="animated-text">Loading...</h4>
    </Container>
  );
};

export default Loading;
